export default __webpack_public_path__ + "static/media/chrome_icon.fe74ad5a.png";